import { DateTime } from 'luxon';

import { TimeZoneEnums } from '@nhl/nhl-breakaway-ui';

export const SYSTEM_ZONE = Intl.DateTimeFormat().resolvedOptions().timeZone;

// basically this creates a time in the input timezone and compares the output of 'timezone name' from luxon. If it
// matches one of the ones from our enum, then we have a synonym and will just use that to determine which item
// in the timezone picker to display.
export const getTimezoneSynonym = (timezone: string): TimeZoneEnums | undefined => {
    const inputTimezoneDisplay = DateTime.local({ zone: timezone }).toLocaleString({ timeZoneName: 'short' });

    const canonicalTimezoneKey = Object.keys(TimeZoneEnums).find((key) => {
        const testTimezone: TimeZoneEnums = TimeZoneEnums[key];

        if (testTimezone !== TimeZoneEnums.VENUE) {
            const testTimezoneDisplay = DateTime.local({ zone: testTimezone }).toLocaleString({
                timeZoneName: 'short',
            });

            return inputTimezoneDisplay === testTimezoneDisplay;
        }

        return false;
    });

    return canonicalTimezoneKey ? TimeZoneEnums[canonicalTimezoneKey] : undefined;
};
